import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SegmentRepository } from "../../domain/interfaces/SegmentRepository";
import { SegmentEntity } from "../../domain/segment.entity";
import { segmentsQueryKeys } from "../../infrastructure/cache/SegmentsCacheStrategy";
import { useOrchestratorCache } from "../../../shared/hooks/useOrchestratorCache";

export function useSegmentMutations(propertyTicker: string, repository: SegmentRepository) {
  const queryClient = useQueryClient();
  const { regenCache } = useOrchestratorCache();

  const invalidateList = () =>
    queryClient.invalidateQueries({ queryKey: segmentsQueryKeys.list(propertyTicker) });

  const createSegment = useMutation({
    mutationFn: (entity: SegmentEntity) => repository.create(propertyTicker, entity),
    onSuccess: async () => {
      await invalidateList();
      await regenCache("segments");
    },
  });

  const updateSegment = useMutation({
    mutationFn: (entity: SegmentEntity) => repository.update(propertyTicker, entity),
    onSuccess: async () => {
      await invalidateList();
      await regenCache("segments");
    },
  });

  const deleteSegment = useMutation({
    mutationFn: (id: string) => repository.delete(propertyTicker, id),
    onSuccess: async () => {
      await invalidateList();
      await regenCache("segments");
    },
  });

  return {
    createSegment: createSegment.mutateAsync,
    updateSegment: updateSegment.mutateAsync,
    deleteSegment: deleteSegment.mutateAsync,
  };
}
